import React from 'react';
import { FormControlLabel, RadioGroup } from '@material-ui/core';
// ? components
import { RadioSelect } from './../../components/RadioButtons';
import Header from './../../components/Header';
// ? store
import CreateContext from './../../store/CreateContext';

function ReportTypeComponent() {
  const context = React.useContext(CreateContext);
  return (
    <div className='col-md-6 col-sm-12 col-xs-12 col-lg-6 col-xl-6'>
      {/* <div className='ml-3'> */}
      <Header
        as='h6'
        icon='fas fa-file-alt fa-lg mr-2'
        title='Report Type'
      />
      {/* </div> */}
      <RadioGroup row aria-label='report-type' name='report-type' value={context.report_type} onClick={(evt) => { console.log('this is the event', evt.target); if (evt.target.value) context.onChangeType(evt.target.value); }}>
        <FormControlLabel
          value='ondemand'
          control={<RadioSelect />}
          label='On Demand'
        />
        <FormControlLabel
          value='scheduled'
          control={<RadioSelect />}
          label='Scheduled'
        />
      </RadioGroup>

    </div>
  );
}

export default ReportTypeComponent;